
	import {Component, Prop, Vue} from "vue-property-decorator";

	@Component({})
	export default class CnxJsonBinder extends Vue {
		@Prop()
		public json?: string;

		@Prop()
		public component?: string;

		private componentsProps = {};

		public beforeMount() {
			try {
				this.componentsProps = JSON.parse(this.json || '');
			} catch (e) {
				console.error('CnxJsonBinder: Error while parsing json data. ' + this.json, e);
			}
		}
	}
